import React from 'react';
import { Box, Button, Grid, Paper } from '@material-ui/core';
import { Form } from 'react-final-form';
import { INITIAL_VALUES, validate } from './helpers';
import { CountryCodeSelect } from 'components/elements';
import { TextField } from 'mui-rff';

import { func } from 'prop-types';
import { useIsDesktop, useTranslations } from 'components/utilities';
import { sendCode } from 'store/actions';
import { convertApiFormErrors } from 'helpers';

const ForgotPasswordForm = ({ goNext }) => {
	const { t, i18n } = useTranslations();

	const handleSubmit = async (values) => {
		let apiErrors = {};

		try {
			await sendCode(
				values,
				(errors) => {
					apiErrors = convertApiFormErrors(errors);
				},
				() => {
					goNext(values);
				}
			);
		} catch (error) {
			console.error(error);
		}

		return apiErrors;
	};

	const direction = i18n.language === 'en' ? 'row' : 'row-reverse';

	const isDesktop = useIsDesktop();

	const boxPaddings = {
		py: isDesktop ? 12 : 3,
		px: isDesktop ? 12 : 3,
	};

	return (
		<Paper square>
			<Box {...boxPaddings}>
				<Form
					onSubmit={handleSubmit}
					validate={validate(t)}
					initialValues={INITIAL_VALUES}
				>
					{({ handleSubmit, submitting }) => (
						<form onSubmit={handleSubmit}>
							<Grid
								container
								spacing={1}
								alignItems="center"
								direction={direction}
							>
								<Grid item xs={4} md={3}>
									<CountryCodeSelect
										variant="outlined"
										name="country_code"
										disabled={submitting}
									/>
								</Grid>
								<Grid item xs={8} md={9}>
									<TextField
										variant="outlined"
										label={t('register.phoneLabel')}
										name="phone"
										fullWidth
										disabled={submitting}
									/>
								</Grid>
							</Grid>

							<Box pt={6}>
								<Button
									type="submit"
									variant="contained"
									color="primary"
									fullWidth
									size={isDesktop ? 'large' : 'medium'}
									disabled={submitting}
								>
									{t('register.button')}
								</Button>
							</Box>
						</form>
					)}
				</Form>
			</Box>
		</Paper>
	);
};
ForgotPasswordForm.propTypes = {
	goNext: func.isRequired,
};

export default ForgotPasswordForm;
